import { useState, useEffect } from 'react';
import type { TimeRemaining } from './types';
import { INITIAL_TIME } from './types';

function calculateTimeRemaining(targetDate: string): TimeRemaining {
  const target = new Date(targetDate).getTime();
  const now = new Date().getTime();
  const difference = target - now;

  if (difference <= 0) {
    return INITIAL_TIME;
  }

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((difference % (1000 * 60)) / 1000),
    total: difference,
  };
}

export function useCountdownTimer(targetDate: string) {
  const [timeRemaining, setTimeRemaining] = useState<TimeRemaining>(INITIAL_TIME);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const initial = calculateTimeRemaining(targetDate);
    setTimeRemaining(initial);
    setIsExpired(initial.total <= 0);

    const interval = setInterval(() => {
      const updated = calculateTimeRemaining(targetDate);
      setTimeRemaining(updated);
      setIsExpired(updated.total <= 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return { timeRemaining, isExpired };
}
